const cubicBezier = (x1, y1, x2, y2) => {
  const b = (a, c, t) =>
    3 * a * (1 - t) * (1 - t) * t + 3 * c * (1 - t) * t * t + t * t * t;
  return function (p) {
    let lo = 0;
    let hi = 1;
    for (let i = 0; i < 20; i++) {
      const t = (lo + hi) / 2;
      if (b(x1, x2, t) < p) lo = t;
      else hi = t;
    }
    return b(y1, y2, (lo + hi) / 2);
  };
}

const easeOut = cubicBezier(0.3, 0, 0, 1);
const ease = cubicBezier(0.5, 0, 0.3, 1);
